// Slovenian
export const sl = {
    weeklyRewards: 'Tedenske nagrade v',
    days: 'dni',
    hours: 'ur',
    minutes: 'min',
    seconds: 'sek',
    authenticating: 'Preverjanje',
    verifyWallet: 'Prosimo počakajte, medtem ko preverjamo vašo denarnico',
    authRequired: 'Potrebna je avtentikacija',
    authFailed: 'Avtentikacija ni uspela. Prosimo, poskusite znova.',
    points: 'Točke',
    rank: 'Mesto',
    of: 'od',
    players: 'igralcev',
    weeklyTopPlayers: 'Najboljši igralci tedna',
    thisWeekLeaderboard: 'Lestvica tega tedna',
    rankingsReset: 'Lestvica se ponastavi vsako nedeljo ob polnoči UTC',
    yourPoints: 'Vaše točke',
    dailyRewardAvailable: 'Dnevna nagrada na voljo!',
    nextClaimAvailable: 'Naslednje prevzem na voljo čez:',
    claimDailyReward: 'Prevzemi dnevno nagrado',
    claiming: 'Prevzemanje...',
    multiplier: 'Množitelj',
    bonusPointsMultiplier: 'Množitelj bonus točk',
    outOf: 'od',
    loading: 'Nalaganje...',
    errorLoading: 'Napaka pri nalaganju',
    noEntries: 'Ni vnosov',
    leaderboard: 'Lestvica',
    tasks: 'Naloge',
    rules: 'Pravila',
    profile: 'Profil',
    comingSoon: 'Kmalu...',
    completedTasks: 'Opravljene naloge',
    dailyRewardsClaimed: 'Prevzete dnevne nagrade',
    times: 'krat',
    recentActivity: 'Nedavna aktivnost',
    noRewardsClaimed: 'Še ni prevzetih nagrad',
    dailyReward: 'Dnevna nagrada',
    howItWorks: 'Kako deluje',
    welcomeMessage:
        'Dobrodošli v Coinomi Rewards! Pridobite točke z opravljanjem različnih nalog in se povzpnite po lestvici.',
    dailyRewardsTitle: 'Dnevne nagrade',
    dailyRewardsRules: [
        'Prevzemite dnevno nagrado vsakih 24 ur',
        'Vsak prevzem je vreden 100 točk',
        'Točke se pomnožijo z vašim množiteljem',
    ],
    multiplierBonusesTitle: 'Bonusi množitelja',
    multiplierBonusesRules: [
        'Začnite z množiteljem 1x',
        'Povežite Telegram za +10% bonus',
        'Potrdite e-pošto za +10% bonus',
        'Bonusi se seštevajo za maksimalne nagrade',
    ],
    leaderboardTitle: 'Lestvica',
    leaderboardRules: [
        'Tekmujte z drugimi igralci',
        'Lestvica se posodablja v realnem času',
        'Najboljši igralci prejmejo posebne nagrade',
    ],
    boostEarningsTitle: 'Povečajte svoje zaslužke',
    boostEarningsRules: [
        'Opravite izzive za bonuse',
        'Pridružite se naši Telegram skupnosti',
        'Ostanite aktivni za maksimalne nagrade',
    ],
    challenges: 'Izzivi',
    telegramChallenge: 'Telegram izziv',
    emailChallenge: 'E-poštni izziv',
    connectTelegram: 'Poveži s Telegramom',
    shareEmail: 'Deli e-pošto',
    telegramSuccess: '🎉 Čestitke! Zdaj prejemate stalni 10% bonus na vse nagrade!',
    telegramPrompt: 'Povežite svoj Telegram račun za stalni 10% bonus na vse nagrade!',
    emailSuccess: '🎉 Čestitke! Zdaj prejemate stalni 10% bonus na vse nagrade!',
    emailPrompt: 'Delite svojo e-pošto za stalni 10% bonus na vse nagrade!',
    connectEmail: 'Poveži e-pošto',
    cancel: 'Prekliči',
    emailPrivacy: 'Vašo e-pošto uporabljamo samo za pomembne posodobitve in obvestila o nagradah.',
    connectYourEmail: 'Povežite svojo e-pošto',
    emailBonus: '🎉 Prejmite stalni 10% bonus na vse nagrade s povezavo svoje e-pošte!',
    enterValidEmail: 'Prosimo, vnesite veljaven e-poštni naslov',
    emailAddress: 'E-poštni naslov',
    errorSavingEmail: 'Napaka pri shranjevanju e-pošte. Prosimo, poskusite znova.',
    claimButton: 'Prevzemi',
    earnedReward: 'Zaslužena nagrada',
    rewardValue: '{{amount}} Točk',
    claimingReward: 'Prevzemanje...',
    claimSuccess: 'Uspešno prevzetih {{amount}} točk!',
    claimError: 'Prevzem ni uspel. Prosimo, poskusite znova.',
    privacyDisclaimer:
        'Coinomi ne zbira osebnih podatkov; sistem tretje osebe varno upravlja s točkami in družbenimi povezavami.',
    streakBonus: 'Bonus zaporedja',
    streakDays: '{{days}}/5 Dni',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Dodatno',
    streakDescription: 'Prevzemite 5 dni zapored za maksimalni bonus',
    streakToday: 'Danes',
    streakMissed: 'Zamujeno',
    streakComplete: 'Končano',
    streakActive: 'Aktivno zaporedje',
    streakLost: 'Izgubljeno zaporedje',
    streakNext: 'Naslednje',
    home: 'Domov',
    currentStreak: 'Trenutno zaporedje',
    totalClaims: 'Skupni prevzemi',
    userStats: 'Vaša statistika',
    referrals: 'Priporočila',
    referralProgram: 'Program priporočil',
    howReferralWorks: 'Kako delujejo priporočila:',
    referralSteps: [
        'Delite svojo povezavo za priporočila s prijatelji',
        'Ko se pridružijo preko vaše povezave, postanejo vaši priporočenci',
        'Prislužite si bonus točke za vsako aktivno priporočilo',
        'Spremljajte svoja priporočila in zaslužke tukaj',
    ],
    referralRewards: 'Dodeljene točke za priporočila:',
    referralBonuses: [
        '100 točk za priporočilo',
        '10% vseh točk, ki jih zaslužijo vaši priporočenci',
    ],
    yourReferralLink: 'Vaša povezava za priporočila',
    copyToClipboard: 'Kopiraj v odložišče',
    linkCopied: 'Povezava kopirana v odložišče!',
    totalReferrals: 'Skupna priporočila',
    yourReferralCode: 'Vaša koda za priporočila',
    referralCodeCopied: 'Koda za priporočila kopirana!',
    editReferralCode: 'Uredi kodo za priporočila',
    editReferralCodeInstructions:
        'Izberite novo kodo za priporočila. Mora imeti vsaj 5 znakov in lahko vsebuje črke in številke.',
    newReferralCode: 'Nova koda za priporočila',
    referralCodeRequirements: 'Najmanj 5 znakov, samo črke in številke',
    updating: 'Posodabljanje...',
    update: 'Posodobi',
    referralCodeTaken: 'Ta koda za priporočila je že zasedena',
    haveReferralCode: 'Imate kodo za priporočila?',
    enterReferralCodePrompt:
        'Če vas je nekdo priporočil, vnesite njihovo kodo tukaj za povezavo računov.',
    enterReferralCode: 'Vnesite kodo za priporočila',
    enterReferralCodeInstructions: 'Vnesite kodo za priporočila, ki je bila deljena z vami.',
    referralCode: 'Koda za priporočila',
    referralCodeFormat: 'Samo črke in številke',
    submitting: 'Pošiljanje...',
    submit: 'Pošlji',
    enterCode: 'Vnesite kodo',
    pleaseAddtoken: 'Prosimo, dodajte parameter token v URL',
    authenticationError: 'Med preverjanjem pristnosti je prišlo do napake',
    noUserFound: 'Uporabnik ni najden',
    userNotFoundMessage: 'Podatkov uporabnika ni bilo mogoče najti',
    backToHome: 'Nazaj na domov',
    retry: 'Poskusi znova',
    baseMultiplier: 'Osnovni množitelj',
    telegramBonus: 'Telegram bonus',
    referralChallenge: 'Izziv priporočil',
    referralChallengePrompt:
        'Povabite prijatelje in si prislužite bonus točke! Prejmite 100 točk za vsako priporočilo plus 10% njihovih zaslužkov.',
    startReferring: 'Začni priporočati',
    referralSuccess: '🎉 Čestitke! Uspešno ste priporočili uporabnike in si služite bonus točke!',
    unranked: 'Nerazvrščeno',
    noPlayersYet: 'Bodite prvi, ki se pridruži!',
    shareVia: 'Deli preko',
    shareOn: 'Deli na {{network}}',
    shareInviteText:
        '🚀 Zaslužujem brezplačno kriptovaluto z @CoinomiWallet!\n\nPrenesite Coinomi z coinomi.com/downloads in vnesite mojo kodo za priporočila {{referralCode}}, da prejmete bonus, ko se pridružite #Coinomi Rewards v aplikaciji.',
    // Twitter Challenge
    twitterChallenge: 'Twitter Izziv',
    connectTwitter: 'Poveži Twitter',
    twitterSuccess: '🎉 Čestitamo! Zdaj prejemate trajni 10% bonus na vse nagrade!',
    twitterPrompt: 'Povežite svoj Twitter račun za trajni 10% bonus na vse nagrade!',
    pleaseAddUserId: 'Prosimo, dodajte parameter userId v URL',
    emailChallengePrompt: 'Delite svojo e-pošto za stalni 10% bonus na vse nagrade!',
    emailChallengeSuccess: '🎉 Povezano! Zdaj prejemate stalni 10% bonus na vse nagrade!',
    followKoalaWalletChallenge: 'Sledite @coinomiWallet na Twitterju, da nas podprete!',
    twitterAuthSuccessTitle: 'Twitter uspešno povezan!',
    twitterAuthSuccessMessage:
        'Vaš Twitter račun je uspešno povezan. Zdaj lahko nadaljujete z uporabo aplikacije.',
    continueToApp: 'Nadaljuj v aplikacijo',
    twitter_like: 'Všečkan tweet',
    twitter_retweet: 'Retweetan tweet',
    disconnect: 'Prekini povezavo',
    followCoinomiWallet: 'Sledite @coinomiWallet na Twitterju, da nas podprete!',
    connectedBonus: '🎉 Povezano! Zdaj prejemate stalni 10% bonus na vse nagrade!',
};
